import { render, staticRenderFns } from "./MenuPopup.vue?vue&type=template&id=5f3c11d8"
import script from "./MenuPopup.vue?vue&type=script&lang=js"
export * from "./MenuPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f3c11d8')) {
      api.createRecord('5f3c11d8', component.options)
    } else {
      api.reload('5f3c11d8', component.options)
    }
    module.hot.accept("./MenuPopup.vue?vue&type=template&id=5f3c11d8", function () {
      api.rerender('5f3c11d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/MenuPopup.vue"
export default component.exports